import { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import "../../assets/css/dashboard-redesign.css";
import { useNavigate } from "react-router-dom";
import { KPI_CARDS } from "utils/constant.js";
import areatrekBg from "../../assets/img/areatrekbg.png";
import { getDashboardStats } from "../../api/ApiServices";

const Header = () => {
  const navigate = useNavigate();

  const [stats, setStats] = useState({
    totalTravelers: null,
    totalGuides: null,
    pendingVerification: null,
  });

  const [loading, setLoading] = useState(true);

  // Get Dashboard Stats
  const fetchDashboardStats = async () => {
    try {
      setLoading(true);

      const response = await getDashboardStats();

      console.log("Dashboard Stats API Response:", response);

      if (response?.success) {
        setStats(response.data);
      }
    } catch (error) {
      console.error("Dashboard Stats Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  // Format dashboard numbers
  const formatValue = (value) => {
    if (loading) {
      return "...";
    }

    if (value === null || value === undefined) {
      return "--";
    }

    if (typeof value === "number") {
      if (value >= 1000000) {
        return `${(value / 1000000).toFixed(1)}M`;
      }

      if (value >= 1000) {
        return `${(value / 1000).toFixed(1)}K`;
      }

      return value.toString();
    }

    return value;
  };

  // Get KPI value from stats
  const getValue = (key) => {
    return formatValue(stats?.[key]);
  };

  return (
    <div
      className="header pb-8 pt-md-1"
      style={{
        backgroundImage: `url(${areatrekBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container fluid>
        <div className="header-body">
          <Row className="align-items-center mb-3">
            <Col lg="12">
              <h2 className="system-overview-title text-white pt-3">
                System Overview
              </h2>

              <p className="system-overview-subtitle mb-0">
                Monitor LocalMate travelers, guides, bookings,
                tours and platform performance.
              </p>
            </Col>
          </Row>
          <Row className="kpi-row">
            {KPI_CARDS.map((card, index) => (
              <Col
                lg="4"
                xl="3"
                md="6"
                key={card.key || index}
                className="d-flex mb-4"
              >
                <Card
                  className={`kpi-card border-0 w-100 ${
                    card.route ? "cursor-pointer" : ""
                  }`}
                  onClick={() => {
                    if (card.route) {
                      navigate(card.route, { state: card.state });
                    }
                  }}
                  role={card.route ? "button" : undefined}
                  tabIndex={card.route ? 0 : undefined}
                  onKeyDown={(e) => {
                    if (card.route && (e.key === "Enter" || e.key === " ")) {
                      e.preventDefault();
                      navigate(card.route, { state: card.state });
                    }
                  }}
                  style={{
                    cursor: card.route ? "pointer" : "default",
                    userSelect: "none",
                  }}
                >
                  <CardBody className="p-4">
                    <div className="d-flex justify-content-between align-items-start">
                      <div
                        className="kpi-icon-container"
                        style={{
                          backgroundColor: card.bgColor,
                        }}
                      >
                        <i
                          className={`${card.icon} ${card.iconClass}`}
                        />
                      </div>

                      {/* TREND */}
                      <div
                        className={`kpi-trend ${card.trendClass || ""}`}
                      >
                        {card.isBadge ? (
                          <span>{card.trend}</span>
                        ) : (
                          <>
                            <i className="fas fa-chart-line mr-1" />
                            {card.trend}
                          </>
                        )}
                      </div>
                    </div>
                    <div className="kpi-label mt-4">
                      {card.label}
                    </div>
                    <div
                      className={`kpi-value mt-1 ${card.valueClass || ""}`}
                    >
                      {getValue(card.key)}
                    </div>

                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

        </div>
      </Container>
    </div>
  );
};

export default Header;
